<template>
    <div>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item >
                    <el-input v-model="form.keyword" placeholder="请输入关键字" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="loadData">搜索</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card>
            <el-table :data="tableData" v-loading="loading">
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="投诉编号" prop="serialNumber" minWidth="140"></el-table-column>
                <el-table-column label="标题" prop="title" minWidth="120"></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/addMyComplaints',
                                        query: { type:'edit',serialNumber:scope.row.serialNumber,callback:request }}">
                            <el-button type="text">查看</el-button>
                        </router-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    // import { statusLists } from "./event.config";
    import services from "./complaintsManage.service";
    import commonService from "../../services/common.service";
    export default {
        data() {
            return {
                form:{
                    user:"",
                    pageSize:10,
                    pageIndex:1,
                },
                total:null,
                tableData:[],
                loading:false,
                ExportBtn:false,
            }
        },
        created() {
            this.form.user=window.localStorage.getItem('internalUserid')
            this.request();
            // this.getCategoryList();     // 获取事件分类


        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
        },
        methods: {

            loadData(){
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                this.form.pageIndex = 1;
                this.request();
            },
            request(){
                // 获取列表数据
                services.myComplaintsList(this.form).then(res => {
                    this.tableData = res.data;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            deleteRole(row){
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.deteleEvent({ serialNumber:row.serialNumber }).then(res => {
                        this.$message.success("删除成功");
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.request();
            },

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
